import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const LoginUser = createAsyncThunk(
  "user/LoginUser",
  async (user, thunkAPI) => {
    try {
      const response = await axios.post(`${api}auth/login`, {
        username: user.username,
        password: user.password,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const SignupUser = createAsyncThunk(
  "user/SignupUser",
  async (user, thunkAPI) => {
    try {
      const response = await axios.post(`${api}auth/register`, {
        nim: user.nim,
        nama: user.nama,
        id_fakultas: user.id_fakultas,
        id_prodi: user.id_prodi,
        no_hp: user.no_hp,
        email: user.email,
        tahun_angkatan: user.tahun_angkatan,
        password: user.password,
        confirmPassword: user.confirmPassword,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const VerifUser = createAsyncThunk(
  "user/VerifUser",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(`${api}user/data`, {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // login
    builder.addCase(LoginUser.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(LoginUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = action.payload;
    });
    builder.addCase(LoginUser.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload;
    });
    // create user
    builder.addCase(SignupUser.pending, loadingHandler);
    builder.addCase(SignupUser.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(SignupUser.rejected, rejectedHandler);
    // verif login
    builder.addCase(VerifUser.pending, loadingHandler);
    builder.addCase(VerifUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = action.payload;
    });
    builder.addCase(VerifUser.rejected, rejectedHandler);
  },
});

export const { reset } = authSlice.actions;
export default authSlice.reducer;
